import { render } from "./EventAnalytics.vue?vue&type=template&id=2aa610e5&scoped=true"
import script from "./EventAnalytics.vue?vue&type=script&lang=js"
export * from "./EventAnalytics.vue?vue&type=script&lang=js"

import "./EventAnalytics.vue?vue&type=style&index=0&id=2aa610e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa610e5"]])

export default __exports__